import { IAuthRequest, IAuthResponse } from '@domain/interfaces/auth/auth-request.interface';
import { User } from '@domain/models/account-settings/user.model';
import { Observable } from 'rxjs';

export abstract class AuthGateway {
  abstract login(user: IAuthRequest, memberPortalServiceURL: string): Observable<IAuthResponse>;
  abstract getUser(): Observable<User>;
  abstract logout(): void;
}
